/**
 * Canonical frontend route paths (kebab-case).
 * Use these for internal navigation, breadcrumbs, and hub cards.
 */
export const appRoutes = {
    dashboard: "/dashboard",
    operations: "/operations",
    transportParties: "/transport-parties",
    codes: "/codes",
    system: "/system",
    systemSetup: "/system-setup",
    settings: "/settings",
    users: "/users",
    userProfile: "/user",
    company: "/company",
    organisations: "/organisations",
    websiteSettings: "/website-settings",
    automaticEmails: "/automatic-emails",
    automaticEmailsEdit: "/automatic-emails/edit",
    admin: "/admin",
    invitations: "/invitations",
    userSessions: "/user-sessions",
    checklists: "/checklists",
    auditLogs: "/audit-logs",
    companyDiary: "/company-diary",
    myTasks: "/my-tasks",
    tasks: "/tasks",
    myCalendar: "/my-calendar",
    documents: "/documents",
    wasteTypes: "/waste-types",
    signIn: "/signin",
    accessDenied: "/accessdenied",
} as const;

/** Build task detail path (`/tasks/:id`). */
export function taskDetailPath(taskId: string): string {
    return `${appRoutes.tasks}/${encodeURIComponent(taskId)}`;
}
